const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const formatDateToDDMMYYYYWithSlash = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

const formatDateToCustomFormat = (dateString) => {
  if (!dateString) return '-';
  try {
    // Create date in local timezone
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';

    // Get local date components
    const day = String(date.getDate()).padStart(2, '0');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Get local time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12 for 12-hour format

    // Format: 16 Oct 2023, 3:20 PM (local time)
    return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

const formatDateToDDMMMYYYY = (dateString) => {
  if (!dateString) return '';

  try {
    const [day, month, year] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const monthName = monthNames[date.getMonth()];
    const dayOfMonth = date.getDate();
    const fullYear = date.getFullYear();

    return `${dayOfMonth} ${monthName} ${fullYear}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

const formatDateTimeSeparately = (dateTimeString) => {
  if (!dateTimeString) return { date: '-', time: '' };

  try {
    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) return { date: '-', time: '' };

    // Format date as "08 Nov 2023"
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = String(date.getDate()).padStart(2, '0');
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Format time as "04:02 AM/PM"
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const formattedTime = `${hours}:${minutes} ${ampm}`;

    return {
      date: `${day} ${monthName} ${year}`,
      time: formattedTime,
    };
  } catch (error) {
    console.error('Error formatting date/time:', error);
    return { date: '-', time: '' };
  }
};

const formatDateOnly = (dateTimeString) => {
  if (!dateTimeString) return '-';

  try {
    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) return '-';

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = String(date.getDate()).padStart(2, '0');
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${monthName} ${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

const formatTimeOnly = (dateTimeString) => {
  if (!dateTimeString) return '';

  try {
    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) return '';

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${hours}:${minutes} ${ampm}`;
  } catch (error) {
    console.error('Error formatting time:', error);
    return '';
  }
};

const formatDateRange = (dateRange) => {
  if (!dateRange) return '';

  // Split the range into start and end dates
  const [startDateStr, endDateStr] = dateRange.split(' - ');

  const formatSingleDate = (dateStr) => {
    if (!dateStr) return '';

    // Parse the date string (DD-MM-YYYY)
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    // Format as "D MMM YYYY" (e.g., "1 JAN 2025")
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dayNum = date.getDate();
    const monthName = months[date.getMonth()];

    return `${dayNum} ${monthName} ${year}`;
  };

  const formattedStart = formatSingleDate(startDateStr);
  const formattedEnd = formatSingleDate(endDateStr);

  return `${formattedStart} - ${formattedEnd}`;
};
const parseDateFromDDMMYYYY = (value) => {
  if (typeof value !== 'string') return null;
  const [day, month, year] = value.split('-').map(Number);
  if (!day || !month || !year) return null;
  return new Date(year, month - 1, day);
};
const formatDisplayDate = (dateStr) => {
  if (!dateStr) return '-';
  // Accepts 'dd-mm-yyyy hh:mm:ss' or 'dd-mm-yyyy'
  const [datePart] = dateStr.split(' ');
  const [dd, mm, yyyy] = datePart.split('-');
  if (!dd || !mm || !yyyy) return dateStr;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthName = months[parseInt(mm, 10) - 1];
  return `${dd} ${monthName} ${yyyy}`;
};

export {
  formatDateToDDMMYYYY,
  formatDateToDDMMYYYYWithSlash,
  formatDateToCustomFormat,
  formatDateToDDMMMYYYY,
  formatDateOnly,
  formatTimeOnly,
  formatDateTimeSeparately,
  formatDateRange,
  parseDateFromDDMMYYYY,
  formatDisplayDate,
};
